<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem dos Avisos.</span>
                <br />
                <span class="navigation">Cadastros > Avisos</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row align-items-end">
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar
                  id="dataIni"
                  name="dataIni"
                  v-model="dataIni"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  placeholder="Período Inicial"
                  @keyup.enter="pesquisar"
                  v-maska="'##/##/####'"
                />
              </span>
            </div>

            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar
                  id="dataFim"
                  name="dataFim"
                  v-model="dataFin"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  placeholder="Período Final"
                  @keyup.enter="pesquisar"
                  v-maska="'##/##/####'"
                />
              </span>
            </div>

            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <Dropdown
                  id="situacao"
                  v-model="filtroSituacao"
                  :options="filtrosSituacao"
                  optionLabel="name"
                  title="Selecione uma Situação"
                  placeholder="Selecione uma Situação"
                />
              </span>
            </div>

            <div class="col-md-2 col-lg-2 mb-3">
              <span class="p-fluid">
                <Button
                  label="Pesquisar"
                  title="Pesquisar"
                  icon="pi pi-search"
                  :disabled="search"
                  @click="pesquisar()"
                  style="width: 130px"
                />
              </span>
            </div>
          </div>
          <div class="row">
            <DataTable
              :value="avisoList"
              :paginator="true"
              :rows="10"
              class="p-datatable-responsive"
              :autoLayout="true"
            >
              <Column headerStyle="width: 10em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button
                    type="button"
                    icon="pi pi-pencil"
                    style="margin-right: .5em"
                    label="Editar"
                    @click="detail(slotProps.data.id)"
                  ></Button>
                </template>
              </Column>
              <Column field="dataVigenciaInicialFormatada" header="Data Vigência Inicial" :style="{'text-align': 'center'}"></Column>
              <Column field="dataVigenciaFinalFormatada" header="Data Vigência Final" :style="{'text-align': 'center'}"></Column>
              <Column field="tipoFormatado" header="Tipo" :style="{'text-align': 'center'}"></Column>
              <Column field="titulo" header="Título"></Column>
              <!-- <Column field="statusAtividadeFormatado" header="Status" :style="{'text-align': 'center'}"></Column> -->
            </DataTable>
          </div>
          <hr />

          <div class="row">
            <span class="p-fluid mr-2">
              <router-link to="/avisoCadastro">
                <Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
              </router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import AvisoService from "../services/nfse/aviso.service";
import CustomCalendar from '../components/global/CustomCalendar.vue';

export default {
  name: "avisoConsulta",
  components:{
    CustomCalendar
  },
  data() {
    return {
      loading: false,
      display: false,
      search: false,
      currentUser: null,
      filtro: "",
      avisoList: [],
      avisoId: null,
      admin: 'N',
      filtrosSituacao: [
        { name: 'Todos', key: 'T' },
        { name: 'Ativos', key: 'A' },
        { name: 'Inativos', key: 'I' },
      ],
      filtroSituacao: '',
      dataIni: null,
      dataFin: null
      // disableInatAviso: false,
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    //só possibilitara a edição se o parametro admin tiver na url usuarios estão indevidamente bloqueando os grupos
    this.admin = (this.$route.query.admin != null && this.$route.query.admin != '' ? this.$route.query.admin : 'N');
    this.pesquisar();

  },
  methods: {
    clear() {
      this.filtro = "";
      this.pesquisar();
    },
    pesquisar() {
      if (!this.dataIni) {
        this.dataIni = null;
      }
      if (!this.dataFin) {
        this.dataFin = null;
      }
      console.log(this.filtroSituacao);
      console.log(this.filtroSituacao.key);
      this.search = true;
      AvisoService.findAllAvisos(
        this.currentUser.usuario.idCliente,
        this.dataIni,
        this.dataFin,
        (this.filtroSituacao ? this.filtroSituacao.key : 'T')
      ).then(
        response => {
          const dataAtual = new Date();
          const mapTipoEnvio = {
            T: 'Exibir após o Login de todos os contribuintes',
            S: 'Exibir após o Login de um contribuinte específico',
            L: 'Exibir na tela de Login',
            P: 'Exibir na tela de Login como popup'
          };
          this.avisoList = (response.data || []).map(aviso => {
            let disableInatAviso = false;
            if (
              aviso.dataVigenciaFinal !== null &&
              aviso.dataVigenciaFinal !== undefined &&
              aviso.dataVigenciaFinal !== ""
            ) {
              const dataFinal = new Date(aviso.dataVigenciaFinal);
              disableInatAviso = dataAtual > dataFinal;
            }
            const tipoFormatado =
              aviso.tipoEnvio === 'P' && (!aviso.tipoFormatado || aviso.tipoFormatado === 'P')
                ? mapTipoEnvio.P
                : aviso.tipoFormatado || mapTipoEnvio[aviso.tipoEnvio] || '';
            return {
              ...aviso,
              tipoFormatado,
              disableInatAviso
            };
          });
          this.search = false;
        },
        error => {
          let errorMessage = "Houve um problema ao listar os Avisos!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
          this.search = false;
        }
      );
    },
    detail(avisoId) {
      this.$router.push({ name: "avisoCadastro", params: { id: avisoId } });
    },
    desativarAviso(aviso){
      if(aviso != null){
        AvisoService.desativarAviso(aviso).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Aviso Desativado com Sucesso!",
            life: 3000
          });
          this.pesquisar();
        },
        error => {
          let errorMessage = "Houve um problema ao desativar o Aviso!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
            life: 3000
          });
        }
      );
      }
    },
    confirmRemove(avisoId) {
      this.perfilId = avisoId;
      this.display = true;
    },
    close() {
      this.avisoId = null;
      this.display = false;
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped>
</style>